"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getElementErrorBoundaryProps = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _constants = require("../constants");
var sceneErrorBoundaryProps = {
  sectionWidth: '100%',
  buttonText: 'Reload',
  iconType: 'failure',
  reloadIcon: false,
  reloadButtonPosition: 'center'
};
var bannerErrorBoundaryProps = {
  buttonText: 'Reload Item',
  iconType: 'failure',
  reloadIcon: true,
  reloadButtonPosition: 'right',
  sectionWidth: '188px',
  sectionMargin: '0px'
};
var overlaysBackgroundsErrorBoundaryProps = {
  buttonText: 'Reload Item',
  iconType: 'failure',
  reloadIcon: true,
  reloadButtonPosition: 'center',
  sectionWidth: '100%'
};
var programAreaErrorBoundaryPops = {
  header: 'Something went wrong!',
  description: 'There was a problem loading Main Program. Please try to reload this feature and if the problem persists, reach out to client support.',
  buttonText: 'Reload',
  iconType: 'failure',
  reloadIcon: false,
  reloadButtonPosition: 'left',
  sectionTextAlign: 'left',
  sectionWidth: '498px',
  sectionMargin: '16px 190px 170px 320px'
};
var getSourceErrorBoundaryProp = function getSourceErrorBoundaryProp() {
  return {
    sectionWidth: '200px',
    buttonText: 'Reload',
    iconType: 'failure',
    reloadIcon: false,
    reloadButtonPosition: 'center',
    sectionHeight: '136px',
    sectionMargin: '0 16px 16px 0'
  };
};
var getElementErrorBoundaryProps = exports.getElementErrorBoundaryProps = function getElementErrorBoundaryProps(componentType) {
  var _errorBoundaryProps;
  var errorBoundaryProps = (_errorBoundaryProps = {}, (0, _defineProperty2["default"])(_errorBoundaryProps, _constants.SCENE, sceneErrorBoundaryProps), (0, _defineProperty2["default"])(_errorBoundaryProps, _constants.SOURCE, getSourceErrorBoundaryProp()), (0, _defineProperty2["default"])(_errorBoundaryProps, _constants.BANNER, bannerErrorBoundaryProps), (0, _defineProperty2["default"])(_errorBoundaryProps, _constants.OVERLAY_BACKGROUND, overlaysBackgroundsErrorBoundaryProps), (0, _defineProperty2["default"])(_errorBoundaryProps, _constants.PROGRAM_AREA, programAreaErrorBoundaryPops), _errorBoundaryProps);
  return errorBoundaryProps[componentType];
};